/** AssignmentRuleの判定結果 */
export const RULE_MATCHING = {
  /** 期待する Role === 実際の Role */
  MATCHED: 'MATCHED',
  /** アサインメントルール上、どの権限にも紐付いていないPersonがAppUserと紐づいている */
  VIOLATED: 'VIOLATED',
  /** 期待する Role !== 実際の Role */
  VIOLATED_ROLE: 'VIOLATED_ROLE',
  /** User がいるが、 Worker が紐づいていない */
  NO_WORKER: 'NO_WORKER',
  /** Worker がいるが、 User が紐づいていない */
  NO_USER: 'NO_USER',
  /** どのルールにも当てはまらない */
  UNDEFINED: 'UNDEFINED',
} as const;
export type RuleMatching = (typeof RULE_MATCHING)[keyof typeof RULE_MATCHING];
